import i18n from 'i18next'
import HttpApi from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // lng: 'es-MX',
    backend: {
      loadPath: '/assets/i18n/{{ns}}/{{lng}}.json'
    },
    fallbackLng: 'es-MX',
    supportedLngs: ['es-MX', 'en'],
    debug: false,
    ns: ['translations'],
    defaultNS: 'translations',
    // keySeparator: false,
    interpolation: {
      escapeValue: false,
      formatSeparator: ','
    },
    react: {
      wait: true,
      useSuspense: false
    }
  })

export default i18n